import QuestionOfTheDay from '@views/flashcards/questionOfTheDay';
import QuestionOfTheDayV2 from '@views/flashcards-v2/questionOfTheDay';

export default [
  {
    path: '/qotd/:categoryId?/:flashcardId?',
    name: 'qotd#index',
    component: QuestionOfTheDay,
    meta: {
      masteryHeader: true,
    },
  },
  {
    path: '/qotd-v2/:date?',
    name: 'qotd-v2#show',
    component: QuestionOfTheDayV2,
    meta: {
      masteryHeader: true,
    },
  },
];
